export default __webpack_public_path__ + "static/media/bonus4.0ffcab20.svg";